module.exports = __webpack_public_path__ + "img/umeal-logo.8de60e9a.jpeg";